'use es6';

import http from 'hub-http/clients/apiClient';
const BASE_URL = '/cosemail/v1/subscription-definitions';
const GROUPS_BASE_URL = '/subscriptions/v1/preferences-group/all/with-permissions';
const TIMEOUT = 30000;
export const fetchActiveSubscriptions = options => http.get(`${BASE_URL}/ensure-active-and-list`, {
  timeout: TIMEOUT,
  query: options
});
export const fetchSubscriptionGroups = () => {
  return http.get(GROUPS_BASE_URL, {
    timeout: TIMEOUT
  });
};